<mat-toolbar id="arcus-toolbar" color="primary" class="mat-whiteframe-1dp">
    <div id="nav-div" class="d-flex justify-content-between align-items-center gap-3 w-100 flex-wrap flex-md-nowrap">
        <div id="menu-loc-nav" class="d-flex align-items-center">
            <button id="toolbar-logo" aria-label="arcus logo button" [routerLink]="'/'"></button>
            <arcus-breadcrumb></arcus-breadcrumb>
        </div>

        <div class="d-flex justify-content-end align-items-center gap-2">
            <button class="arcus-nav-button" mat-icon-button (click)="login()" matTooltip="Login" aria-label="login">
                <fa-icon icon="arrow-right-to-bracket" class="white"></fa-icon>
            </button>
        </div>
    </div>
</mat-toolbar>
